export default __webpack_public_path__ + "static/media/team.bcf67402.jpg";